/**
 * Coach Bio Modal
 * Handles opening and closing of coach bio modals
 */
;(function () {
  'use strict'

  // Open modal on button click
  document.querySelectorAll('[data-coach-dialog]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      var modal = document.getElementById(btn.dataset.coachDialog)
      if (modal) modal.showModal()
    })
  })

  // Close on close button click
  document.querySelectorAll('.rd-coach-dialog__close-button').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      var dialog = btn.closest('dialog')
      if (dialog) dialog.close()
    })
  })

  // Close on backdrop click
  document.querySelectorAll('.rd-coach-dialog').forEach(function (modal) {
    modal.addEventListener('click', function (e) {
      var rect = modal.getBoundingClientRect()
      var isInDialog =
        rect.top <= e.clientY &&
        e.clientY <= rect.top + rect.height &&
        rect.left <= e.clientX &&
        e.clientX <= rect.left + rect.width
      if (!isInDialog) modal.close()
    })
  })
})()
